module.exports = __webpack_public_path__ + "static/media/bg_vip_service.afdb2276.png";